import React, { useState } from "react";

//Import Breadcrumb
import { Box, Chip, FormControl, FormHelperText, FormLabel } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

const CustomSelectChip = ({ title, error, onChange, placeholder, values, disabled, isOptional, margin, data, valueName, labelName, width, multiple }) => {
    const [selectedValues, setSelectedValues] = useState(values || []);

    const handleChipClick = (value) => {
        if (!multiple) {
            // Single selection mode
            setSelectedValues([value]);
            onChange([value]);
        } else {
            // Multiple selection mode
            const isSelected = selectedValues.includes(value);
            const updatedValues = isSelected
                ? selectedValues.filter((v) => v !== value)
                : [...selectedValues, value];

            setSelectedValues(updatedValues);
            onChange(updatedValues);
        }
    };

    return (
        <FormControl
            variant="outlined"
            fullWidth={width ? false : true}
            error={error ? true : false}
        >
            {title && (
                <FormLabel
                    style={{
                        fontFamily: 'FunnelSans',
                        fontWeight: 500,
                        fontSize: 14,
                        paddingBottom: '10px',
                        margin: 0,
                        color: '#1D1B1B',
                    }}
                >
                    <div style={{
                        justifyContent: "space-between",
                        display: "flex",
                    }}>{title}
                        {isOptional ? <span className="optional-label">Optional</span> : null}</div>

                </FormLabel>
            )
            }
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    backgroundColor: disabled ? '#f1f3f4' : 'inherit',
                    paddingTop: '10px',
                    borderRadius: '12px',
                    // border: error ? '1px solid #BA2727' : '1px solid #E6E6E6',
                }}
            >
                {data.map((item) => (
                    <Chip
                        key={item[valueName] || item.id || item.value}
                        label={item[labelName] || item.name || item.label}
                        clickable={!disabled}
                        onClick={() => !disabled && handleChipClick(item[valueName] || item.id || item.value)}
                        sx={{
                            backgroundColor: selectedValues.includes(item[valueName] || item.id || item.value)
                                ? 'rgba(0, 0, 0, 0.1)' // Transparent black background when selected
                                : 'white',
                            color: selectedValues.includes(item[valueName] || item.id || item.value)
                                ? '#1D1B1B'
                                : '#000000',
                            fontFamily: 'FunnelSans',
                            fontWeight: 500,
                            fontSize: 14,
                            border: selectedValues.includes(item[valueName] || item.id || item.value)
                                ? '1px solid black' // Black border when selected
                                : '1px solid #E6E6E6',
                            borderRadius: '8px',
                            '&:hover': {
                                border: '1px solid black',
                                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            },
                        }}
                    />
                ))}
            </Box>
            {
                error && (
                    <FormHelperText
                        sx={{
                            color: '#BA2727',
                            fontFamily: 'FunnelSans',
                            fontSize: 14,
                            marginTop: '5px',
                        }}
                    >
                        {error}
                    </FormHelperText>
                )
            }
        </FormControl >
    );
};

export default CustomSelectChip;
